import { CopyButton } from "@tracify/ui/copy-button";

import { PencilIcon } from "@heroicons/react/24/outline";
import { memo } from "react";
import type { ChatMessage } from "@tracify/shared";
import { sanitizeText } from "@/lib/ai/utils";
import { cn } from "@/lib/utils";
import {
  MessageAction,
  MessageActions as MessageActionsSlot,
} from "@/components/ai-elements/message";

export function PureChatMessageActions({
  chatId,
  message,
  isLoading,
  onEdit,
  isEditing,
  className,
}: {
  chatId: string;
  message: ChatMessage;
  isLoading: boolean;
  onEdit?: () => void;
  isEditing?: boolean;
  className?: string;
}) {
  if (isLoading) return null;
  if (message.role === "user" && isEditing) return null;

  const textFromParts = message.parts
    ?.filter((part) => part.type === "text")
    .map((part) => sanitizeText(part.text ?? ""))
    .filter((text) => text.trim().length > 0)
    .join("\n")
    .trim();

  const isUserMessage = message.role === "user";

  return (
    <MessageActionsSlot className={cn("flex-row gap-2 self-end", className)}>
      {isUserMessage && onEdit ? (
        <MessageAction
          data-testid="message-edit-button"
          tooltip="Edit message"
          onClick={onEdit}
        >
          <PencilIcon className="size-4" />
        </MessageAction>
      ) : null}
      <CopyButton
        value={textFromParts ?? ""}
        copyLabel="message"
        disabled={!textFromParts}
      />
    </MessageActionsSlot>
  );
}

export const ChatMessageActions = memo(PureChatMessageActions);
